import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import usePageTracking from './hooks/usePageTracking';
import About from './pages/About';
import Banking from './pages/Banking';
import Coaching from './pages/Coaching';
import Contact from './pages/Contact';
import CoWorking from './pages/CoWorking';
import Corporate from './pages/Corporate';
import Demo from './pages/Demo';
import Events from './pages/Events';
import GatedCommunities from './pages/GatedCommunities';
import Gyms from './pages/Gyms';
import Healthcare from './pages/Healthcare';
import Home from './pages/Home';
import Hostels from './pages/Hostels';
import Hotels from './pages/Hotels';
import JanSevaKendra from './pages/JanSevaKendra';
import Logistics from './pages/Logistics';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Retail from './pages/Retail';
import ReligiousTrusts from './pages/ReligiousTrusts';
import Schools from './pages/Schools';
import Leads from './pages/Leads';
import LogoEditor from './pages/LogoEditor';
import Proposal from './pages/Proposal';
import Terms from './pages/Terms';

function AppShell() {
  usePageTracking();
  return (
    <div className="App flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-grow pt-16 lg:pt-[4.25rem]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/logo" element={<LogoEditor />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/co-working" element={<CoWorking />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/events" element={<Events />} />
          <Route path="/banking" element={<Banking />} />
          <Route path="/gated-communities" element={<GatedCommunities />} />
          <Route path="/jan-seva-kendra" element={<JanSevaKendra />} />
          <Route path="/gyms" element={<Gyms />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/schools" element={<Schools />} />
          <Route path="/hostels" element={<Hostels />} />
          <Route path="/retail" element={<Retail />} />
          <Route path="/religious-trusts" element={<ReligiousTrusts />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/proposal" element={<Proposal />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppShell />
      </Router>
    </HelmetProvider>
  );
}

export default App;
